import { httpClient } from '../http/httpClient.js';
import { buildQueryString } from '../tasks/serviceUtils.js';

const USERS_API_URL = '/api/users';

const buildUsersUrl = (params = {}) => {
  const queryString = buildQueryString(params);
  return queryString ? `${USERS_API_URL}?${queryString}` : USERS_API_URL;
};

const buildUsersResponse = (payload) => ({
  users: getUsersCollection(payload).map(normalizeUser),
  pagination: payload?.pagination || null,
  payload
});

const getUsersCollection = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.users)) {
    return payload.users;
  }

  if (Array.isArray(payload?.responses)) {
    return payload.responses;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload?.items)) {
    return payload.items;
  }

  return [];
};

export const normalizeUser = (user) => ({
  ...user,
  id: user?.id ?? user?._id ?? user?.email ?? null,
  name: user?.name ?? '',
  email: user?.email ?? '',
  phone: user?.phone ?? '',
  role: user?.role ?? ''
});

const buildUserUpdatePayload = (userData) => {
  const payload = { ...userData };

  delete payload.confirmPassword;

  if (!payload.password?.trim()) {
    delete payload.password;
  }

  return payload;
};

export const isDuplicateEmailError = (error) => {
  const message = String(error?.message || '').toLowerCase();
  const code = String(error?.payload?.code || error?.data?.code || '');

  return (
    error?.status === 409
    || code === '23505'
    || message.includes('email ya esta en uso')
    || message.includes('email ya está en uso')
    || message.includes('llave duplicada')
    || message.includes('duplicate')
  );
};

export const userService = {
  getUsers: async (params = {}) => {
    const payload = await httpClient.get(buildUsersUrl(params));
    const usersResponse = buildUsersResponse(payload);

    if (!params || Object.keys(params).length === 0) {
      return usersResponse.users;
    }

    return usersResponse;
  },

  getTechnicians: async () => {
    const payload = await httpClient.get(`${USERS_API_URL}/technicians`);
    return getUsersCollection(payload).map(normalizeUser);
  },

  createUser: async (userData) => {
    return httpClient.post(USERS_API_URL, { data: userData });
  },

  updateUser: async (email, userData) => {
    return httpClient.put(`${USERS_API_URL}/${encodeURIComponent(email)}`, {
      data: buildUserUpdatePayload(userData)
    });
  },

  deleteUser: async (email) => {
    return httpClient.delete(`${USERS_API_URL}/${encodeURIComponent(email)}`);
  },

  changeCompany: async (companyId) => {
    return httpClient.put(`${USERS_API_URL}/changeCompany`, {
      data: { companyId }
    });
  }
};
